import { useState, useEffect, useCallback } from "react";
import API from "utils/api";

export default function useWellnessTasks() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTasks = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await API.get("/wellness-coach/tasks");
      setData(response.data);
    } catch (err) {
      console.error("Failed to fetch wellness tasks:", err);
      setError(err.message || "Failed to fetch wellness tasks");
    } finally {
      setLoading(false);
    }
  }, []);

  const completeTask = useCallback(async (instanceId, notes = "") => {
    try {
      await API.put(`/wellness-coach/tasks/instances/${instanceId}/complete`, { notes });
      await fetchTasks(); // Refresh the list
      return true;
    } catch (err) {
      console.error("Failed to complete task:", err);
      return false;
    }
  }, [fetchTasks]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return { data, loading, error, refetch: fetchTasks, completeTask };
}
